import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { THEME } from './globalStyles';


export default function Text({children,titleSize,titleLevel,strong, ...rest}){
  let size;
  let color;
  let lineHeigth="1.6em";
  if(titleSize===1) size = "1em";
  else if(titleSize===2) size = "1.15em";
  else if(titleSize===3)size = "1.8em";
  else if(titleSize===4)size = "2.4em";
  else {
    size = "0.75em";
    lineHeigth="1.15em";
  }

  if(titleLevel===1) color = THEME.colors.darkBlue;
  else if(titleLevel===2)color = THEME.colors.ligthBlue;
  else if(titleLevel===3)color = THEME.colors.blue;
  else if(titleLevel===4)color = THEME.colors.mediumGrey;
  else color = THEME.colors.darkGrey;

  return (
    <CustomText {...rest} size={size} color={color} lineHeigth={lineHeigth} strong={strong}>
      {children}
    </CustomText>
  )
}
const CustomText = styled.p`
  font-size: ${(p)=>p.size};
  color: ${(p)=>p.color};
  margin: 0 0 4px 0;
  line-height: ${p=>p.lineHeigth};
  font-weight: ${p=>p.strong?600:400};
  min-width: fit-content;
`;

Text.propTypes = {
  titleSize: PropTypes.oneOf([1,2,3,4]),
  titleLevel: PropTypes.oneOf([1,2,3,4])
}